import type { SurveyLookAndFeelSettings } from "../types/Survey";

export function makeCssVars(styles: SurveyLookAndFeelSettings): string {
    function makeVarIfSet(varName: string, value?: string, suffix?: string): string {
        if (value) {
            return ` ${varName}: ${value}${suffix || ""};`;
        }
        return "";
    }

    let cssVars = "";
    cssVars += makeVarIfSet("--title-font-size", styles.titleFontSize, "px");
    cssVars += makeVarIfSet("--title-text-align", styles.titleAlignment);
    cssVars += makeVarIfSet("--title-color", styles.titleColor);
    cssVars += makeVarIfSet("--title-font-weight", styles.titleFontWeight);

    cssVars += makeVarIfSet("--text-font-size", styles.textFontSize, "px");
    cssVars += makeVarIfSet("--text-text-align", styles.textAlignment);
    cssVars += makeVarIfSet("--text-color", styles.textColor);
    cssVars += makeVarIfSet("--text-font-weight", styles.textFontWeight);

    cssVars += makeVarIfSet("--next-button-color", styles.nextButtonTextColor);
    cssVars += makeVarIfSet("--next-button-background-color", styles.nextButtonBackgroundColor);
    cssVars += makeVarIfSet("--next-button-font-weight", styles.nextButtonFontWeight);
    cssVars += makeVarIfSet("--next-button-letter-spacing", styles.nextButtonLetterSpacing);
    cssVars += makeVarIfSet("--next-button-text-transform", styles.nextButtonTextTransform?.toLowerCase());
    if (styles.nextButtonBackgroundGradient) {
        const gradientStyle =
            styles.nextButtonBackgroundGradient.direction === "LeftToRight"
                ? `linear-gradient(to right, ${styles.nextButtonBackgroundGradient.startColor} 0%, ${styles.nextButtonBackgroundGradient.endColor} 100%)`
                : `linear-gradient(to bottom, ${styles.nextButtonBackgroundGradient.startColor} 0%, ${styles.nextButtonBackgroundGradient.endColor} 100%)`;
        cssVars += ` --next-button-background-image: ${gradientStyle};`;
    }

    return cssVars;
}